import { render } from "./faqDetail.vue?vue&type=template&id=27b9c68d&scoped=true"
import script from "./faqDetail.vue?vue&type=script&lang=js"
export * from "./faqDetail.vue?vue&type=script&lang=js"

import "./faqDetail.vue?vue&type=style&index=0&id=27b9c68d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b9c68d"]])

export default __exports__